/*
 * Validação de campos que não admitem duplicatas no banco de dados. Esta validação depende de um serviço
 * que faz o acesso ao servidor para verificar a existência do valor informado na base de dados. O serviço
 * a ser utilizado para a validação de cada tipo de campo pode ser configurado pela aplicação cliente
 * através de um configurador Angular para o respectivo service provider.
 */
angular.module("avlib").directive("avUniqueValidation", 
		["$log", "$q", "$timeout", "msgDisplayService", "uniqueValidationService",
		function($log, $q, $timeout, msgDisplayService, uniqueValidationService){

	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){
			// Para evitar conflitos de múltiplas definições de escopo com outras diretivas,
			// obtemos os valores dos atributos diretamente, ao invés de definir um escopo independente para essa diretiva

			// Tipo de campo que será validado (cpf, cnpj), a ser definido pela aplicação via configurador do serviço
			var validationField = attrs.avUniqueValidation;

			// O id do objeto que está sendo validado. Para discriminar se o servidor achou a própria instância na base
			var safeId = scope.$eval(attrs.avUniqueValidationSafeId);

			var doAsyncValidation = function(modelValue){
				if (modelValue){
					var numberPromise =	uniqueValidationService.check(validationField, modelValue).then(function(response){
						if (!response.data || response.data == safeId){
							return $q.resolve(true);
						}else{
							return $q.reject("Código já existente");
						}
					}, function(response){
						msgDisplayService.showToast("Falha na consulta ao servidor");
						return $q.resolve("Falha na consulta ao servidor");
					});
					return numberPromise;
				}else{
					return $q.resolve(true);
				}
			};

			// https://github.com/angular/angular.js/issues/13788
			// https://stackoverflow.com/questions/33088856/debounce-on-only-one-validator#answer-33103155

			var pendingValidation = null;

			ctrl.$asyncValidators.avUnique = function(modelValue, viewValue) {

				if (pendingValidation) $timeout.cancel(pendingValidation);

				pendingValidation = $timeout(function(){
					pendingValidation = null;
					// returns promise or value
					return doAsyncValidation(modelValue);
				}, 500);

				return pendingValidation;
			}; // validator function
		} // link
	}; // return object
}]); // directive
